siteBgSettingsDirective = angular.module('sitebg.setting', [])


siteBgSettingsDirective.directive "siteBgSettings", ["$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "ContentEditable", "Widget", "blockEditDialog", "$rootScope", "Parallax", "Page", "$translate", "$filter", ($window, $timeout, $compile, $templateCache, ns, translitService, ContentEditable, Widget, blockEditDialog, $rootScope, Parallax, Page, $translate, $filter) ->
  restrict: "A",
  scope: {data: "=ngModel"},
  templateUrl: "#{settingFolder}/siteBgSettings/template.jade"
  link: (scope, element, attrs, ngModel) ->

    bodyElement = $("#tpl-wrapper")
    scope.reloadUploader = true

    renderStyleBg = (newVal) ->
      bodyElement.css newVal

    scope.removePageBackground = ->
      scope.reloadUploader = false

      Page.remove_background($rootScope.currentPage.id).then ->
        scope.data.background_attributes.image_attributes = null
        renderImageBg scope.data.background_attributes
        scope.reloadUploader = true


    renderImageBg = (newVal) ->
      if newVal.image_attributes and newVal.image_attributes.source_url
        bodyElement.css {backgroundImage: "url('#{newVal.image_attributes.source_url}')"}
      else
        bodyElement.css {backgroundImage: ""}

      if newVal.gradient
        setGradient newVal
      else
        removeGradient()
      if newVal.parallax
        scope.data.style_attributes.backgroundPosition = "center 0px"
        Parallax.initSection $rootScope.Y.one("#tpl-wrapper")
      else
        scope.data.style_attributes.backgroundPosition = ""
        Parallax.destroy $rootScope.Y.one("#tpl-wrapper")

    listener = scope.$watch "data.style_attributes", (newVal) ->
      renderStyleBg newVal
    , true

    listener2 = scope.$watch "data.background_attributes", (newVal) ->
      renderImageBg newVal
    , true


    removeGradient = (background_attributes) ->
      if $("style##{$rootScope.currentPage.id}").length > 0
        $("style##{$rootScope.currentPage.id}").html "#tpl-wrapper:before { background-image:none; }"
      else
        $('body').append("<style id='#{$rootScope.currentPage.id}'>#tpl-wrapper:before { background-image:none; }</style>");

    setGradient = (background_attributes) ->
      color_start = background_attributes.color_start
      color_stop = background_attributes.color_stop
      gradient_css = "
        background-image:-moz-linear-gradient(top, #{color_start}, #{color_stop});
        background-image:-webkit-linear-gradient(top, #{color_start}, #{color_stop});
        background-image:-o-linear-gradient(top, #{color_start}, #{color_stop});
        background-image:-ms-linear-gradient(top, #{color_start}, #{color_stop});,
        background-image:linear-gradient(top, #{color_start}, #{color_stop});
        filter: progid:DXImageTransform.Microsoft.gradient(startColorStr='#{color_start}', endColorstr='#{color_stop}');"
      if $("style##{$rootScope.currentPage.id}").length > 0
        $("style##{$rootScope.currentPage.id}").html "#tpl-wrapper:before { #{gradient_css} }"
      else
        $('body').append("<style id='#{$rootScope.currentPage.id}'>#tpl-wrapper:before { #{gradient_css} }</style>");


    setSectionBgFixed = (page) ->
      page.style_attributes.backgroundAttachment = "fixed"
      page.background_attributes.parallax = false

    setSectionBgParallax = (page) ->
      page.style_attributes.backgroundAttachment = "inherit"
      page.background_attributes.parallax = true

    setSectionBgNoEffect = (page) ->
      page.background_attributes.parallax = false
      page.style_attributes.backgroundAttachment = "inherit"

    setSectionBgRepeat = (page) ->
      page.style_attributes.backgroundRepeat = "repeat"
      page.style_attributes.backgroundSize = "initial"

    setSectionBgCover = (page) ->
      page.style_attributes.backgroundRepeat = "no-repeat"
      page.style_attributes.backgroundSize = "cover"

    setSectionBgNoOption = (page) ->
      page.style_attributes.backgroundRepeat = "no-repeat"
      page.style_attributes.backgroundSize = "initial"

    scope.bgOptions = [
      {
        name: "none",
        name_ru: $filter('translate')('editor.panel.blockSettings.section.background1.size1')
      },
      {
        name: "repeat",
        name_ru: $filter('translate')('editor.panel.blockSettings.section.background1.size2')
      },
      {
        name: "cover",
        name_ru: $filter('translate')('editor.panel.blockSettings.section.background1.size3')
      }
    ]

    scope.contentEffects = [
      {
        name: "none",
        name_ru: $filter('translate')("editor.panel.blockSettings.section.effect1")
      },
      {
        name: "top",
        name_ru: $filter('translate')("editor.panel.blockSettings.section.effect2")
      },
      {
        name: "left",
        name_ru: $filter('translate')("editor.panel.blockSettings.section.effect3")
      },
      {
        name: "right",
        name_ru: $filter('translate')("editor.panel.blockSettings.section.effect4")
      },
      {
        name: "bottom",
        name_ru: $filter('translate')("editor.panel.blockSettings.section.effect5")
      },
      {
        name: "fade",
        name_ru: $filter('translate')("editor.panel.blockSettings.section.effect6")
      },
      {
        name: "zoom",
        name_ru: $filter('translate')("editor.panel.blockSettings.section.effect7")
      }
    ]

    scope.getNameContentType = (type) ->
      switch type
        when "none"
          return scope.contentEffects[0].name_ru
        when "top"
          return scope.contentEffects[1].name_ru
        when "left"
          return scope.contentEffects[2].name_ru
        when "right"
          return scope.contentEffects[3].name_ru
        when "bottom"
          return scope.contentEffects[4].name_ru
        when "fade"
          return scope.contentEffects[5].name_ru
        when "zoom"
          return scope.contentEffects[6].name_ru

    scope.setBgOption = (name, page) ->
      switch name
        when "none"
          setSectionBgNoOption page
        when "repeat"
          setSectionBgRepeat page
        when "cover"
          setSectionBgCover page
      return



    scope.bgEffects = [
      {
        name: "none",
        name_ru: $filter('translate')("editor.panel.blockSettings.section.background1.backgroundEffect1")
      },
      {
        name: "fixed",
        name_ru: $filter('translate')("editor.panel.blockSettings.section.background1.backgroundEffect2")
      },
      {
        name: "parallax",
        name_ru: $filter('translate')("editor.panel.blockSettings.section.background1.backgroundEffect3")
      }
    ]


    scope.setBgEffect = (name, section) ->
      switch name
        when "none"
          setSectionBgNoEffect section
        when "fixed"
          setSectionBgFixed section
        when "parallax"
          setSectionBgParallax section
      return


    scope.$on "$destroy", ->
      listener()



]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/siteBgSettings/sitebgsettings.directive.coffee